import { memo } from "react";
import { cn } from "@/lib/utils";
import {
  GSC_COMPARE_METRIC_LABELS,
  GSC_COMPARE_METRICS,
  type GscCompareMetric,
} from "@/types/gsc";

export interface CompareMetricSelectorProps {
  activeMetric: GscCompareMetric;
  onChange: (metric: GscCompareMetric) => void;
  className?: string;
}

function CompareMetricSelectorComponent({
  activeMetric,
  onChange,
  className,
}: CompareMetricSelectorProps) {
  return (
    <div
      role="group"
      aria-label="Compare primary metric"
      className={cn(
        "inline-flex w-fit flex-wrap rounded-lg border border-border bg-muted/40 p-0.5",
        className,
      )}
    >
      {GSC_COMPARE_METRICS.map((metric) => {
        const isActive = activeMetric === metric;
        return (
          <button
            key={metric}
            type="button"
            onClick={() => onChange(metric)}
            className={cn(
              "rounded-md px-3 py-1.5 text-xs font-medium whitespace-nowrap transition-colors cursor-pointer",
              isActive
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
            aria-pressed={isActive}
          >
            {GSC_COMPARE_METRIC_LABELS[metric]}
          </button>
        );
      })}
    </div>
  );
}

export const CompareMetricSelector = memo(CompareMetricSelectorComponent);
CompareMetricSelector.displayName = "CompareMetricSelector";
